/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';
import NextLink from 'next/link';

import styles from './TopicCard.module.scss';

import { topicPath } from '../../paths';
import type { TopicCardProps } from './TopicCard.types';

export const TopicCard = ({ topic, lang, className }: TopicCardProps) => (
  <NextLink
    href={topicPath(topic.slug, lang)}
    className={cn(styles['card'], className)}
    data-group={topic.group}
    data-subgroup={topic.subgroup}
  >
    <span className={styles['family']}>{topic.subgroup_name}</span>
    <span className={styles['name']}>{topic.name}</span>
    <span className={styles['definition']}>{topic.definition}</span>
  </NextLink>
);
